import React, { FC, PropsWithChildren, ReactElement } from 'react';

import Popover, { ExternalPopoverProps } from '../Popover';

type Props = PropsWithChildren & {
  externalHandlerProps: ExternalPopoverProps;
  requestClear: () => void;
  trigger: ReactElement;
};

/**
 * Label create popover component
 *
 * @todo Probably remove this component and use MetaContainerPopup when it stars using the new popover
 *
 * @param props                      Props passed to the component
 * @param props.children             The children to render inside the popover
 * @param props.externalHandlerProps Props for managing the popover state from parent component (optional)
 * @param props.requestClear         Callback to clear the form
 * @param props.trigger              The element that triggers the popover
 * @returns                          The component itself
 */
const LabelCreatePopover: FC<Props> = ({
  children,
  externalHandlerProps,
  requestClear,
  trigger,
}) => {
  /**
   * Request to close the popover
   */
  const requestClose = () => {
    externalHandlerProps.onStateChange(null);
    requestClear();
  };

  return (
    <Popover
      anchorOrigin={{
        horizontal: 'right',
        vertical: 'bottom',
      }}
      externalHandlerProps={externalHandlerProps}
      onClose={requestClose}
      transformOrigin={{
        horizontal: 'right',
        vertical: 'top',
      }}
      trigger={trigger}
    >
      {children}
    </Popover>
  );
};

export default LabelCreatePopover;
